import pre from './pre';
import config from './config.vue';
import addon from './addon.vue';
import cart from './cart.vue';

export default {
    pre,
    currencyFilter: ['INR'],
    components: {
        config,
        addon,
        cart,
    },
}
